const closeBracket = {
  match: ')',
}

export default closeBracket
